import React from 'react';
import ReportData from './ReportData';

const ReportFirstChild = (props) => {
    const studyId = props.studyId;
    const studyName  = props.studyName;
    const quadroId = props.quadroId;
    const username = props.username;
    const token = props.token;
    const quadros = props.quadros;
    const quadrosTexto = props.quadrosTexto;

    // 1ª Proteção: Garantir que os arrays já carregaram antes de fazer "find" ou "filter"
    if (!quadros || !quadrosTexto) {
        return <div>A carregar dados do relatório...</div>;
    }

    // Get first child node (CORRIGIDO PARA TEXTO)
    const quadroPai = quadros.find((q) => String(q.id) === String(quadroId));
    
    // 2ª Proteção: Evitar erro se o quadro pai ainda não existir
    if (!quadroPai) {
        return <div>A carregar quadro pai...</div>;
    }

    // Filtrar filhos (CORRIGIDO PARA TEXTO) e garantir que a ordem é respeitada
    const quadrosFilhos = quadros.filter((q) => String(q.quadroPai) === String(quadroPai.id) && q.estado === 1);
    
    // Vamos ordenar pela coluna "ordem" caso o primeiro filho não seja o do ID mais baixo
    quadrosFilhos.sort((a, b) => a.ordem - b.ordem);
    
    const quadro = quadrosFilhos[0];

    // 3ª Proteção: Evitar erro se o quadro pai não tiver filhos ativos (quadro = undefined)
    if (!quadro) {
        return <div>Nenhum quadro filho ativo encontrado.</div>;
    }

    const newQuadroId = quadro.id;
    
    // Ler o nome do quadro (CORRIGIDO PARA TEXTO)
    const quadroTexto = quadrosTexto.find((q) => String(q.id) === String(newQuadroId));
    
    // 4ª Proteção: Garantir que não falha ao ler o nome, caso o texto não exista
    const nomeQuadro = quadroTexto ? quadroTexto.nome : 'Quadro sem nome';
    
    return (
        <ReportData 
            username={username}
            token={token}
            studyId={studyId}
            studyName={studyName}
            selectedNode={newQuadroId} 
            selectedNodeLabel={nomeQuadro}
            quadro={quadro} 
            quadros={quadros} 
            quadrosTexto={quadrosTexto} 
            parentNode={quadroPai}
        />
    );
}

export default ReportFirstChild;